module.exports = __webpack_public_path__ + "img/slide5.e83b3523.jpg";